import React from 'react';
import { Grid2 } from '@mui/material';
import { Typography } from '@mui/material';
import { AccessibilityNewOutlined } from '@mui/icons-material';
// import { useStyles } from './styles';

import svg from 'assets/images/trip-company/friends.svg';
import svg2 from 'assets/images/trip-company/family.svg';
import svg3 from 'assets/images/trip-company/partner.svg';
import svg4 from 'assets/images/trip-company/work.svg';
import svg5 from 'assets/images/trip-company/alone.svg';

export const CustomCheckFavItem = (props) => {
    const { img, label, selected, onClick, disabled } = props;
    const active = selected
        ? `linear-gradient(rgba(42, 129, 232, 1), rgba(42, 129, 232, 1)),`
        : ``;

    const activeText = selected
        ? `linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)),`
        : ``;

    let currentBg = '';
    currentBg = `${active} #DADCE2`;

    let currentColor = '';
    currentColor = `${activeText} #fff`;

    return (
        <Grid2
            style={{
                background: currentBg,
                color: currentColor,
            }}
            item
            className={`profile-triper__travel-preferences-box`}
            container
            onClick={() => onClick(props)}
        >
            <Typography
                className="profile-triper__travel-preferences-option"
                variant="body1"
            >
                {label}
            </Typography>
            <img
                className="profile-triper__travel-preferences-option-img"
                src={img}
                alt=""
            />
        </Grid2>
    );
};
